import { createSlice } from '@reduxjs/toolkit'
import { merge } from 'components/util'
import * as autoThunks from 'features/auto-thunks'
import CoherentScreen from './coherent-screen-model'
import {
  CreateCoherentScreenAsync,
  DeleteCoherentScreenAsync,
  LoadCoherentScreensAsync,
} from './coherentScreen-thunk'
const initialState: coherentScreenSliceState = {
  coherentScreen: [],
  selected_coherentScreen: '',
  is_loading_coherentScreen: false,
  is_creating_coherentScreen: false,
  is_deleting_coherentScreen: false,
}
export interface coherentScreenSliceState {
  coherentScreen: CoherentScreen[]
  selected_coherentScreen?: string
  is_loading_coherentScreen: boolean
  is_creating_coherentScreen: boolean
  is_deleting_coherentScreen: boolean
}
export const coherentScreenSlice = createSlice({
  name: 'coherentScreen',
  initialState,
  reducers: {
    setSelectedcoherentScreen: (state, action) => {
      state.selected_coherentScreen = action.payload
    },
    clearStatecoherentScreen: (state) => {
      state.coherentScreen = []
      state.is_loading_coherentScreen = false
      state.is_creating_coherentScreen = false
      state.is_deleting_coherentScreen = false
    },
    mergecoherentScreen: (state, action) => {
      if (action.payload) {
        let payload: any = action.payload
        if (payload?.data) {
          if (!Array.isArray(payload.data)) {
            state.selected_coherentScreen = payload?.data?.id
            payload = [payload.data]
          } else {
            payload = payload.data
          }
          state.coherentScreen = merge(state.coherentScreen, payload) as any
        }
      }
    },

    add_coherentScreen: (state, action) => {
      if (action.payload) {
        state.coherentScreen = [...state.coherentScreen, action.payload]
      }
    },
    set_coherentScreen: (state, action) => {
      let { key, value, id } = action.payload
      state.coherentScreen = state.coherentScreen.map((item) => {
        if (item && item.id === id) {
          return {
            ...item,
            [key]: value,
          }
        }
        return item
      })
    },
  },
  extraReducers: (builder) => {
    builder.addCase('LOGOUT', () => {
      return { ...initialState }
    })

    builder.addCase(LoadCoherentScreensAsync.pending, (state) => {
      state.is_loading_coherentScreen = true
    })
    builder.addCase(LoadCoherentScreensAsync.fulfilled, (state, action) => {
      state.is_loading_coherentScreen = false
      if (action.payload) {
        state.coherentScreen = action.payload
      }
    })
    builder.addCase(LoadCoherentScreensAsync.rejected, (state) => {
      state.is_loading_coherentScreen = false
    })
    builder.addCase(CreateCoherentScreenAsync.pending, (state) => {
      state.is_creating_coherentScreen = true
    })
    builder.addCase(CreateCoherentScreenAsync.fulfilled, (state) => {
      state.is_creating_coherentScreen = false
    })
    builder.addCase(CreateCoherentScreenAsync.rejected, (state) => {
      state.is_creating_coherentScreen = false
    })
    builder.addCase(DeleteCoherentScreenAsync.pending, (state) => {
      state.is_deleting_coherentScreen = true
    })
    builder.addCase(DeleteCoherentScreenAsync.fulfilled, (state, action) => {
      state.is_deleting_coherentScreen = false
      if (state.coherentScreen) {
        state.coherentScreen = state.coherentScreen.filter(
          (x) => action.payload.id !== x.id,
        )
      }
    })
    builder.addCase(DeleteCoherentScreenAsync.rejected, (state) => {
      state.is_deleting_coherentScreen = false
    })

    builder.addCase(
      autoThunks.store_coherent_screen_for_customer.pending,
      (state) => {
        state.is_loading_coherentScreen = true
      },
    )
    builder.addCase(
      autoThunks.store_coherent_screen_for_customer.fulfilled,
      (state, action) => {
        state.is_loading_coherentScreen = false
        handleResult(action, state)
      },
    )
    builder.addCase(
      autoThunks.store_coherent_screen_for_customer.rejected,
      (state) => {
        state.is_loading_coherentScreen = false
      },
    )

    builder.addCase(
      autoThunks.get_customer_coherent_screens.pending,
      (state) => {
        state.is_loading_coherentScreen = true
      },
    )
    builder.addCase(
      autoThunks.get_customer_coherent_screens.fulfilled,
      (state, action) => {
        state.is_loading_coherentScreen = false
        handleResult(action, state)
      },
    )
    builder.addCase(
      autoThunks.get_customer_coherent_screens.rejected,
      (state) => {
        state.is_loading_coherentScreen = false
      },
    )

    builder.addCase(
      autoThunks.delete_customer_coherent_screens.pending,
      (state) => {
        state.is_loading_coherentScreen = true
      },
    )
    builder.addCase(
      autoThunks.delete_customer_coherent_screens.fulfilled,
      (state, action) => {
        state.is_loading_coherentScreen = false
        handleResult(action, state)
      },
    )
    builder.addCase(
      autoThunks.delete_customer_coherent_screens.rejected,
      (state) => {
        state.is_loading_coherentScreen = false
      },
    )

    builder.addCase(
      autoThunks.retrieve_current_coherent_screen.pending,
      (state) => {
        state.is_loading_coherentScreen = true
      },
    )
    builder.addCase(
      autoThunks.retrieve_current_coherent_screen.fulfilled,
      (state, action) => {
        state.is_loading_coherentScreen = false
        handleResult(action, state)
      },
    )
    builder.addCase(
      autoThunks.retrieve_current_coherent_screen.rejected,
      (state) => {
        state.is_loading_coherentScreen = false
      },
    )

    builder.addCase(autoThunks.get_current_coherent_screen.pending, (state) => {
      state.is_loading_coherentScreen = true
    })
    builder.addCase(
      autoThunks.get_current_coherent_screen.fulfilled,
      (state, action) => {
        state.is_loading_coherentScreen = false
        handleResult(action, state)
      },
    )
    builder.addCase(
      autoThunks.get_current_coherent_screen.rejected,
      (state) => {
        state.is_loading_coherentScreen = false
      },
    )

    builder.addCase(autoThunks.get_coherent_screen_list.pending, (state) => {
      state.is_loading_coherentScreen = true
    })
    builder.addCase(
      autoThunks.get_coherent_screen_list.fulfilled,
      (state, action) => {
        state.is_loading_coherentScreen = false
        handleResult(action, state)
      },
    )
    builder.addCase(autoThunks.get_coherent_screen_list.rejected, (state) => {
      state.is_loading_coherentScreen = false
    })

    builder.addCase(autoThunks.storeCoherentScreenAsync.pending, (state) => {
      state.is_loading_coherentScreen = true
    })
    builder.addCase(
      autoThunks.storeCoherentScreenAsync.fulfilled,
      (state, action) => {
        state.is_loading_coherentScreen = false
        handleResult(action, state)
      },
    )
    builder.addCase(autoThunks.storeCoherentScreenAsync.rejected, (state) => {
      state.is_loading_coherentScreen = false
    })

    builder.addCase(autoThunks.deleteCoherentScreenAsync.pending, (state) => {
      state.is_loading_coherentScreen = true
    })
    builder.addCase(
      autoThunks.deleteCoherentScreenAsync.fulfilled,
      (state, action) => {
        state.is_loading_coherentScreen = false
        handleResult(action, state)
      },
    )
    builder.addCase(autoThunks.deleteCoherentScreenAsync.rejected, (state) => {
      state.is_loading_coherentScreen = false
    })

    builder.addCase(autoThunks.get_default_coherent_screen.pending, (state) => {
      state.is_loading_coherentScreen = true
    })
    builder.addCase(
      autoThunks.get_default_coherent_screen.fulfilled,
      (state, action) => {
        state.is_loading_coherentScreen = false
        handleResult(action, state)
      },
    )
    builder.addCase(
      autoThunks.get_default_coherent_screen.rejected,
      (state) => {
        state.is_loading_coherentScreen = false
      },
    )

    builder.addCase(
      autoThunks.get_coherent_screen_list_for_system_schedules.pending,
      (state) => {
        state.is_loading_coherentScreen = true
      },
    )
    builder.addCase(
      autoThunks.get_coherent_screen_list_for_system_schedules.fulfilled,
      (state, action) => {
        state.is_loading_coherentScreen = false
        handleResult(action, state)
      },
    )
    builder.addCase(
      autoThunks.get_coherent_screen_list_for_system_schedules.rejected,
      (state) => {
        state.is_loading_coherentScreen = false
      },
    )

    builder.addCase(autoThunks.get_all_coherentScreens.pending, (state) => {
      state.is_loading_coherentScreen = true
    })
    builder.addCase(
      autoThunks.get_all_coherentScreens.fulfilled,
      (state, action) => {
        state.is_loading_coherentScreen = false
        handleResult(action, state)
      },
    )
    builder.addCase(autoThunks.get_all_coherentScreens.rejected, (state) => {
      state.is_loading_coherentScreen = false
    })
  },
})

function handleResult(action: any, state: coherentScreenSliceState) {
  if (action.payload) {
    let payload: any = action.payload
    if (payload?.data) {
      if (!Array.isArray(payload.data)) {
        state.selected_coherentScreen = payload?.data?.id
        payload = [payload.data]
      } else {
        payload = payload.data
      }
      state.coherentScreen = merge(state.coherentScreen, payload) as any
    }
  }
}

export const {
  clearStatecoherentScreen,
  setSelectedcoherentScreen,
  set_coherentScreen,
  mergecoherentScreen,
  add_coherentScreen,
} = coherentScreenSlice.actions

export const get_coherentScreen =
  (id?: string) =>
  (state: {
    coherentScreen: {
      coherentScreen: CoherentScreen[]
    }
  }): CoherentScreen | null => {
    let temp = state?.coherentScreen?.coherentScreen?.find((v) => v.id === id)
    if (temp) {
      return temp
    }
    return state?.coherentScreen?.coherentScreen[0] || null
  }
export const get_selected_coherentScreen = (state: {
  coherentScreen: coherentScreenSliceState
}): CoherentScreen | null => {
  let id = state?.coherentScreen?.selected_coherentScreen
  let temp = state?.coherentScreen?.coherentScreen?.find((v) => v.id === id)
  if (temp) {
    return temp
  }
  return null
}
export const get_all_coherentScreen = (state: {
  coherentScreen: {
    coherentScreen: CoherentScreen[]
  }
}): CoherentScreen[] => {
  let temp = state?.coherentScreen?.coherentScreen
  if (temp) {
    return temp.filter((x) => !x.deleted)
  }
  return []
}
export const is_coherentScreen_busy = (state: {
  coherentScreen: coherentScreenSliceState
}) => {
  return (
    state?.coherentScreen.is_deleting_coherentScreen ||
    state?.coherentScreen.is_loading_coherentScreen ||
    state?.coherentScreen.is_creating_coherentScreen
  )
}
export const is_deleting_coherentScreen_busy = (state: {
  coherentScreen: coherentScreenSliceState
}) => {
  return state?.coherentScreen.is_deleting_coherentScreen
}
export const is_loading_coherentScreen_busy = (state: {
  coherentScreen: coherentScreenSliceState
}) => {
  return state?.coherentScreen.is_loading_coherentScreen
}
export const is_creating_coherentScreen_busy = (state: {
  coherentScreen: coherentScreenSliceState
}) => {
  return state?.coherentScreen.is_creating_coherentScreen
}

export default coherentScreenSlice.reducer
